import { render, staticRenderFns } from "./PersonalDataForm.vue?vue&type=template&id=135d3d29&scoped=true&"
import script from "./PersonalDataForm.vue?vue&type=script&lang=ts&"
export * from "./PersonalDataForm.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalDataForm.vue?vue&type=style&index=0&id=135d3d29&scoped=true&lang=scss&"
import style1 from "./PersonalDataForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d3d29",
  null
  
)

export default component.exports